import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getCategories, API_BASE_URL } from '../API/endpoint';
import './Boutique.css';

function Boutique() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const data = await getCategories();
      setCategories(data);
      setError('');
    } catch (err) {
      setError('Erreur lors du chargement des catégories');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <main className="App-main">
        <div className="boutique-section">
          <p>Chargement des catégories...</p>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="App-main">
        <div className="boutique-section">
          <p style={{color: 'red'}}>{error}</p>
        </div>
      </main>
    );
  }

  return (
    <main className="App-main">
      <Helmet>
        <title>Boutique - Déco Ariège</title>
        <meta name="description" content="Découvrez notre boutique en ligne de décoration en bois artisanale. Produits faits main, idées cadeaux uniques en Ariège." />
      </Helmet>
      <div className="boutique-section magicpatern3">
        <h1>Boutique</h1>
        <p>Bienvenue dans ma boutique en ligne. Découvrez nos produits par catégorie.</p>
        <div className="boutique-categories-grid">
          {categories.map((category) => (
            <Link key={category.id} to={`/boutique/${category.name.replace(/\s+/g, '-').toLowerCase()}`} className="boutique-category-link">
              <div className="boutique-category-card">
                {category.path && <img src={`${API_BASE_URL}${category.path}`} alt={category.name} />}
                <h3>{category.name}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}

export default Boutique;